module.exports = __webpack_public_path__ + "static/media/moon-icon.c0f0924f.svg";